module.exports = __webpack_public_path__ + "static/img/screenshot-actualities-1.dc018dd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/screenshot-actualities-1.png
// module id = zBSn
// module chunks = 1